import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetDataByMultiChoice {
  message: string;
  result: [
    {
      ID: number;
      LABEL: string;
      NUMBER: number;
      choice_detail: string;
      choice_id: number;
      media: {
        file_name: string;
        file_url: string;
        media_type: string;
      }
    }
  ];
  success: boolean;
}

interface resGetDataByMostLeast {
  message: string;
  result: [
    {
      ID: number;
      NUMBER: number;
      data_answer: [
        {
          choice_detail: string;
          choice_id: number;
        }
      ]
    }
  ];
  success: boolean;
}

interface resGetDataByRating {
  message: string;
  result: [
    {
      ID: number;
      NUMBER: number;
      CHOICES_LENGTH: number;
    }
  ];
  success: boolean;
}

interface resGetDataByRanking {
  message: string;
  result: [
    {
      ID: number;
      NUMBER: number;
      data_answer: [
        {
          choice_detail: string;
          choice_id: number;
        }
      ]
    }
  ];
  success: boolean;
}

interface resCreateReportTemplate {
  success: boolean,
  message: string,
  result: {
    REPORT_ID: string
  }
}

interface resGetAllMeasure {
  success: boolean,
  message: string,
  result: [
    {
      MEASURE_ID: string,
      MEASURE_NAME: string
    }
  ]
}

interface resGetDetailReportById {
  success: boolean,
  message: string,
  result: [
    {
      CREATE_BY: string,
      CREATE_DATE: string,
      IS_VIEW: number,
      MEASURE_ID: string,
      MEASURE_NAME: string,
      PRICE: number,
      REPORT_DES: string,
      REPORT_DES_FREE: string,
      REPORT_DES_NOTFREE: string,
      REPORT_ID: string,
      REPORT_NAME: string,
      STATUS_FREE: string,
      STATUS_NOTFREE: string,
      UPDATE_BY: string,
      UPDATE_DATE: string,
    }
  ]
}

interface resGetAllDashBoardReport {
  success: boolean,
  message: string,
  result: [
    {
      REPORT_ID: string,
      CREATE_DATE: string,
      UPDATE_DATE: string,
      CREATE_BY: string,
      IS_VIEW: number,
      REPORT_DES: string,
      REPORT_NAME: string,
      MEASURE_ID: string,
      REPORT_DES_FREE: string,
      STATUS_FREE: string,
      STATUS_NOTFREE: string,
      REPORT_DES_NOTFREE: string,
      PRICE: number,
      UPDATE_BY: string,
      TEMPLATE_FREE_TYPE: string,
      TEMPLATE_NOTFREE_TYPE: string,
      MEASURE_NAME: string,
      TYPE_PAY: string
    }
  ]
}

interface resGetDetailTemplateById {
  success: boolean,
  message: string,
  result: {
    REPORT_NAME: string,
    TYPE: string,
    TEMPLATE_CATEGORY: string,
    TEMPLATE_DES: string,
    MAX: number,
    PSY_BLOCKS: [
      {
        PSY_GROUP_NAME: string,
        PSY_GROUP_COLOR: string,
        PSY_DATA: [
          {
            PSY_NAME: string,
            MIN: string,
            MAX: string,
            DETAIL_PSY: string,
            CAL: {
              TYPE: string,
              NUM_ANSWER: [
                {
                  ID: string,
                  NUMBER: number,
                  ANSWER: number
                },
              ],
              FORMULA: string,
              M: string,
              SD: string,
              DETAIL: [
                {
                  min_range: number,
                  max_range: number,
                  description: string
                },
              ]
            }
          },
        ]
      }
    ]
  }
}

interface resUpsertTemplate4Box {
  success: boolean,
  message: string,
  result: [
    {
      MEASURE_ID: string,
      update_date: Date
    }
  ]
}

interface resUpsertTemplateProfileMatching {
  success: boolean,
  message: string,
  result: [
    {
      REPORT_ID: string,
      update_date: Date
    }
  ]
}

@Injectable({
  providedIn: 'root'
})
export class ReportManagementService {
  token: string = null;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  creatTemplateProfile(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/manage_report/creatTemplateProfile', body, { headers: headers });
  }

  getDataByMultiChoice(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDataByMultiChoice>(environment.URL + '/manage_report/getDataByCategory', body, { headers: headers });
  }

  getDataByRating(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDataByRating>(environment.URL + '/manage_report/getDataByCategory', body, { headers: headers });
  }

  getDataByRanking(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDataByRanking>(environment.URL + '/manage_report/getDataByCategory', body, { headers: headers });
  }

  getDataByMostLeast(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDataByMostLeast>(environment.URL + '/manage_report/getDataByCategory', body, { headers: headers });
  }

  createReportTemplate(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resCreateReportTemplate>(environment.URL + '/manage_report/createReportTemplate', body, { headers: headers });
  }

  getDataByCategory(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDataByMostLeast>(environment.URL + '/manage_report/getDataByCategory', body, { headers: headers });
  }

  updateReportTemplateById(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/manage_report/updateReportTemplateById', body, { headers: headers });
  }

  getAllMeasureCanUse() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllMeasure>(environment.URL + '/manage_report/getAllMeasureCanUse', { headers: headers });
  }

  getDetailReportById(rpid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetDetailReportById>(environment.URL + '/manage_report/getDetailReportById?REPORT_ID=' + rpid, { headers: headers });
  }

  getAllDashBoardReport() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllDashBoardReport>(environment.URL + '/manage_report/getAllDashBoardReport', { headers: headers });
  }

  upsertTemplateProfile(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resCreateReportTemplate>(environment.URL + '/manage_report/upsertTemplateProfile', body, { headers: headers });
  }

  upsertTemplateSpider(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resCreateReportTemplate>(environment.URL + '/manage_report/upsertTemplateSpider', body, { headers: headers });
  }

  upsertTemplateStd(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resCreateReportTemplate>(environment.URL + '/manage_report/upsertTemplateStd', body, { headers: headers });
  }

  getDetailTemplateByType(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDetailTemplateById>(environment.URL + '/manage_report/getDetailTemplateByType', body, { headers: headers });
  }

  updateStatusViewByReport(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDetailTemplateById>(environment.URL + '/manage_report/updateStatusViewByReport', body, { headers: headers });
  }

  upsertTemplate4Box(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resUpsertTemplate4Box>(environment.URL + '/manage_report/upsertTemplate4Box', body, { headers: headers });
  }

  upsertTemplateProfileMatching(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resUpsertTemplateProfileMatching>(environment.URL + '/manage_report/upsertTemplateProfileMatching', body, { headers: headers });
  }

  upsertTemplateTopRank(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resUpsertTemplateProfileMatching>(environment.URL + '/manage_report/upsertTemplateTopRank', body, { headers: headers });
  }
}
